import { EventTypes_Enum } from '@organice/graphql'
export import EventType = EventTypes_Enum

export const eventTypesSelect = Object.entries(EventType).map(
  ([key, value]) => ({
    value,
    label: `events.${key}`,
  })
)
